<div class="footer">
  <p><a [routerLink]="['/contact']">{{'footer.aide' | transloco}}</a> | <a [routerLink]="['/legal-notices']">{{'footer.mentions.legales' | transloco}}</a> | Version {{ version }} - 2026-10-22 | {{'footer.copyright' | transloco}}</p>
</div>
